import {getAreaQuery} from './get-area'

export const AreaQueries = {getAreaQuery}
